import { Component, Input } from '@angular/core';

import { JobStatusResponse } from '../models/summary.model';

@Component({
  selector: 'opus-job-status-header',
  templateUrl: './job-status-header.component.html'
})
export class JobStatusHeaderComponent {
  @Input() jobStatusResult?: JobStatusResponse;

  get id() {
    return this.jobStatusResult?.id;
  }

  get jobName() {
    return this.jobStatusResult?.jobName;
  }
}
